// extracted by mini-css-extract-plugin
export var container = "styles-module__container___iSWem";
export var long = "styles-module__long___gZPZD";
export var callToAction = "styles-module__callToAction___jtMiK";
export var button = "styles-module__button___fRVx5";
export var active = "styles-module__active___TjXdr";
export var section = "styles-module__section___mquU3";
export var body = "styles-module__body___J3GqJ";
export var sub2 = "styles-module__sub2___oTPCv";
export var image = "styles-module__image___DJegs";
export var short = "styles-module__short___ceoqU";